import { useSetAtom } from 'jotai';
import { useEffect } from 'react';

import { documentTitleState } from 'states/app';

const useDocumentTitle = (title) => {
  const setDocumentTitle = useSetAtom(documentTitleState);
  useEffect(() => {
    setDocumentTitle(title);
  }, [setDocumentTitle, title]);
};

export default useDocumentTitle;
